import { Model, View } from '@lernetz/ts-lib';

import buttonTemplate from './Button.html';


type ButtonType = '-open' | '-open-popup' | '-open-blank';


export class Button extends Model {

    public readonly href: string;
    public readonly text: string;
    public readonly type: ButtonType;
    public readonly target : string;
    public readonly marginTop: string;
    public readonly marginBottom: string;

    constructor(dto) {
        super();
        this.href = dto.href || '#';
        this.text = dto.text;
        this.type = dto.type;
        this.marginTop = dto.marginTop || '';
        this.marginBottom = dto.marginBottom || '';

        this.target = Button.getTarget(this.type);
    }

    private static getTarget(type: string) {
        switch (type) {
            case '-open':
            case '-open-popup':
                return '_self';

            case '-open-blank':
                return '_blank';
        }
    }
}


export class ButtonView extends View<Button> {

    constructor() {
        super({ template: buttonTemplate });
    }
}
